import axios from 'axios'

const instance = axios.create({

  baseURL: 'http://epidemics.space.noa.gr:8889/'
  //baseURL: 'http://192.168.60.11:7000/'
   //baseURL: 'http://127.0.0.1:9001/'
})

// instance.defaults.headers.common['SOMETHING'] = 'something'

export default instance
